import { Helmet } from "react-helmet";
import Navbar from "../../components/shared/Navbar";
import RightBar from "../../components/shared/RightBar";
import Footer from "../../components/shared/Footer";
import BreadCrumbMediaEducation from "../../components/mediaEducation/BreadCrumbLatest";
import Content from "../../components/mediaEducation/Content";

export default function MediaEducation() {
    return(
        <div className="flex flex-col min-h-screen">
            <Helmet>
                <title>Media Edukasi - BPR Palu Anugerah</title>
                <meta name="description" content="Dapat edukasi literasi keuangan bersama BPR Palu Anugerah" />
                <meta name="robots" content="index, follow" />
                <meta property="og:title" content="Media Edukasi - BPR Palu Anugerah" />
                <meta property="og:description" content="Dapat edukasi literasi keuangan bersama BPR Palu Anugerah" />
                <meta property="og:type" content="website" />
            </Helmet>
            <Navbar />
            <RightBar></RightBar>
            <main className="flex-grow">
                <BreadCrumbMediaEducation></BreadCrumbMediaEducation>
                <Content></Content>
            </main>
            <Footer />
        </div>
    )
}